import React from 'react';
import { StyledLoadingContent } from './styles';

interface Props {
  title?: string;
  message?: string;
}

export default function LoadingContent({ title, message }: Props): JSX.Element {
  const { Container, Title, Message, Spinner } = StyledLoadingContent;

  return (
    <Container>
      {title && <Title>{title}</Title>}
      {message && <Message>{message}</Message>}
      <Spinner size={128} />
    </Container>
  );
}
